module.exports = __webpack_public_path__ + "img/thunder.e48bbd3d.svg";